import * as React from 'react';
import {GridColorPicker} from '@deviceinsight/ng-ui-components';
import {Checkbox} from '@deviceinsight/ng-ui-basic-components';
import {
	BLINKING_FREQUENCY,
	COLOR_PALETTE,
	flashingCheckBoxMessage,
	ValueType
} from '../../../modules/ruleengine/config/consts';
import type {DeviceElementTarget, RuleConditionState} from '../../../modules/ruleengine/types';
import GpioToggleButton from '../../GpioToggleButton';
type Props = {
	onChange: (arg0: Partial<RuleConditionState>) => void;
	elementTarget: DeviceElementTarget;
	currentConditionState: Partial<RuleConditionState>;
	canEdit: boolean;
};
type AttrProps = {
	value?: string;
	frequency?: number;
	onChange: (value?: string, frequency?: number) => void;
	unit?: string;
	canEdit: boolean;
};
type NumberAttrProps = {
	value?: number;
	onChange: (value?: number) => void;
	unit?: string;
	canEdit: boolean;
};
type OperatingModeAttrProps = {
	online?: boolean;
	onChange: (value?: boolean) => void;
	canEdit: boolean;
};

const ColorAttr = ({value, frequency, onChange, canEdit}: AttrProps) => {
	return (
		<div className="color-flashing">
			<GridColorPicker
				inline={false}
				colors={canEdit ? COLOR_PALETTE : value ? [value] : []}
				value={value || COLOR_PALETTE[0]}
				onPick={(color) => onChange(color ? color.toUpperCase() : undefined, frequency)}
			/>
			<Checkbox
				value={frequency ? true : false}
				title={flashingCheckBoxMessage}
				label={flashingCheckBoxMessage}
				onChange={() => onChange(value, frequency ? 0 : BLINKING_FREQUENCY)}
				disabled={!canEdit}
			/>
		</div>
	);
};

const NumberAttr = ({value, onChange, unit, canEdit}: NumberAttrProps) => {
	return (
		<span className="number-attr">
			&gt;=
			<input
				type="number"
				onChange={({target: {value}}) => onChange(parseInt(value))}
				value={value || ''}
				className="time-field"
				disabled={!canEdit}
			/>
			{unit}
		</span>
	);
};

const OperatingModeAttr = ({online, onChange, canEdit}: OperatingModeAttrProps) => {
	return (
		<span>
			<select
				value={online as unknown as string}
				onChange={({target: {value}}) => onChange(value === 'true')}
				disabled={!canEdit}>
				<option value="true">Online</option>
				<option value="false">Offline</option>
			</select>
		</span>
	);
};

export default class ElementTargetValues extends React.PureComponent<Props> {
	render() {
		const {currentConditionState, onChange, elementTarget, canEdit} = this.props;
		const {online, color, status, frequency} = currentConditionState;
		const {valueType, unit} = elementTarget;

		switch (valueType) {
			case ValueType.color:
				return (
					<ColorAttr
						value={color}
						frequency={frequency}
						onChange={(color, frequency) =>
							onChange({
								color,
								frequency
							})
						}
						canEdit={canEdit}
					/>
				);

			case ValueType.frequency:
				return (
					<NumberAttr
						value={frequency}
						onChange={(frequency) =>
							onChange({
								frequency
							})
						}
						unit={unit}
						canEdit={canEdit}
					/>
				);

			case ValueType.operatingMode:
				return (
					<OperatingModeAttr
						online={online}
						onChange={(online) =>
							onChange({
								online
							})
						}
						canEdit={canEdit}
					/>
				);

			case ValueType.inputState:
			case ValueType.outputState:
				return (
					<GpioToggleButton
						status={status}
						onChange={(status) =>
							onChange({
								status
							})
						}
						canEdit={canEdit}
					/>
				);

			default:
				return <div />;
		}
	}
}
